import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Zamówienie testowe',
    ordered_at: 'Zamówiono o:',
  },
  delivery_info: {
    info: 'Info o dostawie:',
  },
  order_note: {
    label: 'Uwaga do zamówienia:',
  },
  schedule_info: {
    pickup: 'Odbiór',
    delivery: 'Dostawa',
    on_site: 'Zamówienie do stolika',
    wish_time: 'Życzony czas:',
    confirmed_time: 'Potwierdzony czas:',
    driver_arrival_time: 'Czas odbioru przez kierowcę:',
    external_delivery: 'Zamówienie dostarcza zewnętrzny kierowca z {{carrier}}',
  },
  products: {
    item: 'Pozycja:',
  },
  discount_breakdown: {
    label: 'Rabat',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Zastosowano rabat procentowy od sumy',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Zastosowano rabat procentowy od produktów',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Zastosowano rabat kwotowy od produktów',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Zastosowano rabat kwotowy od sumy',
    [OFFER_KIND.BOGO]: 'Zastosowano BOGO',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Zastosowano BOGO w połowie ceny',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Zastosowano darmową pozycję za produkty',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Zastosowano darmową pozycję za sumę',
    GiftCard: 'Zastosowano kartę podarunkową',
    Reward: 'Zastosowano punkty lojalnościowe',
    CashbackAccount: 'Zastosowano punkty lojalnościowe',
    PromoCodeComponent: 'Zastosowano promocję',
    Offer: 'Zastosowano ofertę',
  },
  payment_breakdown: {
    price: 'Cena:',
    subtotal: 'Suma częściowa',
    delivery_fee: 'Opłata za dostawę',
    tips: 'Napiwek',
    processing_fee: 'Opłata serwisowa online',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Opłata PayPal',
    },
    tax: 'Podatki',
    total: 'Suma',
    paid_amount: 'Kwota zapłacona',
    order_not_paid: 'Zamówienie nie zostało jeszcze opłacone',
    order_paid_online: 'Już opłacone online',
    cash: 'Płatność na miejscu',
    this_is_not_an_invoice: 'To nie jest faktura',
  },
  delivery_qr_code: {
    scan: 'Skanuj i dostarcz z Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
